import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import CheckCard from '../components/CheckCard/CheckCard';
import styles from './Check.module.css';
import checkCardTexts from '../data/checkCardTexts.json';
import { isNeckSoundEnabled } from '../utils/hospitalConfig';
import { Login as LoginIcon, Logout, Person } from '@mui/icons-material';
import { auth } from '../utils/firebase';
import HeaderActions from '../components/Header/HeaderActions';
import { openNeckSoundApp } from '../utils/necksoundApp';

const Check: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hospitalId } = useParams<{ hospitalId: string }>();
  const prefix = hospitalId ? `/${hospitalId}` : '';

  const neckSoundEnabled = isNeckSoundEnabled(hospitalId);

  const checks = Object.entries(checkCardTexts)
    .filter(([key, data]) => {
      // key가 'necksound'인 경우, neckSoundEnabled가 true일 때만 포함합니다.
      if (key === 'necksound') {
        return neckSoundEnabled;
      }
      // 그 외의 카드는 무조건 포함합니다.
      return true;
    })
    .map(([key, data]) => ({
      ...data,
      id: key
    }));
  
  const isLoggedIn = auth.currentUser !== null;

  const handleLoginClick = () => {
    navigate(`${prefix}/login`);
  };

  const handleLogout = async () => {
    const confirmLogout = window.confirm(t('logout_confirm', '로그아웃 하시겠습니까?'));
    if (confirmLogout) {
      await auth.signOut();
      localStorage.clear();
      navigate(`${prefix}/`);
    }
  };

  const handleStart = (checkId: string) => {
    switch (checkId) {
      case 'stroke':
        navigate(`${prefix}/stroke_check`);
        break;
      case 'cognitive':
        navigate(`${prefix}/cognitive_check`);
        break;
      case 'headache':
        navigate(`${prefix}/headache_check`);
        break;
      case 'necksound':
        if (!openNeckSoundApp()) {
          navigate(`${prefix}/necksound_check`);
        }
        break;
      default:
        console.log(`Starting check: ${checkId}`);
    }
  };

  const handleMyInfo = () => {
    navigate(`${prefix}/my-info`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.logoContainer}>
          <span className={styles.logoText}>BrainCheck</span>
        </div>
        <HeaderActions hospitalId={hospitalId} />
      </div>

      <div className={styles.cardsContainer}>
        <div className={styles.cardsScroll}>
          {checks.map((check) => (
            <CheckCard
              key={check.id}
              titleKey={check.titleKey}
              descriptionKey={check.descriptionKey}
              timeKey={check.timeKey}
              imageUrl={check.imageUrl}
              onStart={() => handleStart(check.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Check; 